import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const notificationLogsRoute: InvariantJiraRoute = {
	name: 'notification-logs',
	path: '/jira/servicedesk/projects/:projectKey/notification-logs',
	exact: true,
};
